import { filter, set } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  Divider,
  Paper
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { SecretaryListHead, SecretaryListToolbar, SecretaryMoreMenu } from '../sections/reports';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'fromyear', label: 'From Year', alignRight: false },
  { id: 'toyear', label: 'To Year', alignRight: false },
  { id: 'image', label: 'Image', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, roleFilter) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  let filteredArray = stabilizedThis.map((el) => el[0]);

  // Apply text query filter
  if (query) {
    filteredArray = filteredArray.filter((secretary) => {
      if (String(secretary.fromyear).toLowerCase().includes(query.toLowerCase())) {
        return true;
      }
      if (String(secretary.toyear).toLowerCase().includes(query.toLowerCase())) {
        return true;
      }
      if (secretary.description && secretary.description.toLowerCase().includes(query.toLowerCase())) {
        return true;
      }
      if (secretary.images && secretary.images.toLowerCase().includes(query.toLowerCase())) {
        return true;
      }
      return false;
    });
  }


  // Apply role filter
  if (roleFilter) {
    filteredArray = filteredArray.filter((secretary) =>
      secretary.role.toLowerCase() === roleFilter.toLowerCase()
    );
  }

  return filteredArray;
}

export default function Secretary() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('email'); // Default sort by email
  const [filterName, setFilterName] = useState('');
  const [roleFilter, setRoleFilter] = useState(''); // State for role filter
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // State for secretary
  const [secretary, setSecretary] = useState([]);
  const [editingsecretaryId, setEditingSecretaryId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [name, setName] = useState('');
  const [fromyear, setFromYear] = useState('');
  const [toyear, setToYear] = useState('');
  const [selectedsecretary, setSelectedSecretary] = useState(null);
  const [viewModalOpen, setViewModalOpen] = useState(false);
   const [imageUrl, setImageUrl] = useState('');




  // Fetch secretary from the server on component mount
  useEffect(() => {
    fetchsecretary();
  }, []);

  // Fetch secretary from the server
  const fetchsecretary = async () => {
    try {
      const response = await axios.get('https://cpccbe.org/api/secretary/getAllSecretaries');
      setSecretary(response.data);
    } catch (error) {
      console.error("Error fetching secretary:", error);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = secretary.map((n) => n.email); // Use email as unique identifier
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, email) => {
    const selectedIndex = selected.indexOf(email);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, email);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // Handle opening and closing of modal for editing secretary
  const handleOpenModal = (secretaryId) => {
    if (secretaryId) {

      const secretarytoEdit = secretary.find(secretary => secretary._id === secretaryId);
      if (secretarytoEdit) {
        setName(secretarytoEdit.name);
        setFromYear(secretarytoEdit.fromyear);
        setToYear(secretarytoEdit.toyear);
        setImageUrl(secretarytoEdit.imageUrl);
        setEditingSecretaryId(secretaryId);
      }
    } else {
      setName('')
      setFromYear('');
      setToYear('');
      setImageUrl('');
      setEditingSecretaryId(null);
    }
    setOpenModal(true);

  };


  const handleCloseModal = () => {
    setOpenModal(false);
    setName('')
    setFromYear('');
    setToYear('');
      setImageUrl('');
    setEditingSecretaryId(null);

  };



  // Handle adding a new secretary
  const handleAddsecretary = async () => {
    try {
      const response = await axios.post('https://cpccbe.org/api/secretary/createsecretary', { name, fromyear, toyear, imageUrl }); // Adjust based on your actual data structure

      fetchsecretary(); // Refresh president list after adding
      handleCloseModal(); // Close modal after adding
    } catch (error) {
      console.error("Error adding secretary:", error);
    }
  };

  // Handle updating a secretary
  const handleUpdatesecretary = async () => {
    try {
      await axios.patch(`https://cpccbe.org/api/secretary/updatesecretary/${editingsecretaryId}`, { name, fromyear, toyear, imageUrl }); // Adjust endpoint as necessary
      fetchsecretary(); // Refresh secretary list after updating
      handleCloseModal(); // Close modal after updating
    } catch (error) {
      console.error("Error updating secretary:", error);
    }
  };

  // Handle deleting a secretary
  const handleDeletesecretary = async (secretaryId) => {
    if (window.confirm("Are you sure you want to delete this secretary?")) {
      try {
        await axios.delete(`https://cpccbe.org/api/secretary/deletesecretary/${secretaryId}`); // Adjust endpoint as necessary
        fetchsecretary(); // Refresh president list after deletion
      } catch (error) {
        console.error("Error deleting secretary:", error);
      }
    }
  };

  const handleViewsecretary = (secretary) => {
    // Open a modal or set state to display secretary details
    setSelectedSecretary(secretary); // Assuming you have state to hold selected secretary data
    setViewModalOpen(true); // Open the modal for viewing secretary details
  };




  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - secretary.length) : 0;

  // Apply sorting and filtering
  const filteredsecretary = applySortFilter(secretary, getComparator(order, orderBy), filterName, roleFilter);


  const issecretaryNotFound = filteredsecretary.length === 0;

  return (
    <Page title="secretary">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Secretary
          </Typography>
          <Button variant="contained" onClick={handleOpenModal} startIcon={<Iconify icon="eva:plus-fill" />}>
            New Secretary
          </Button>
        </Stack>

        <Card>
          <SecretaryListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            roleFilter={roleFilter}
            onRoleFilterChange={(e) => setRoleFilter(e.target.value)}
          />


          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <SecretaryListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={secretary.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredsecretary.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { _id, email, role } = row; // Adjust based on your actual data structure
                    const isItemSelected = selected.indexOf(email) !== -1;

                    return (
                      <TableRow
                        hover
                        key={_id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell align="left">
                          <IconButton onClick={() => handleViewsecretary(row)} aria-label="view secretary">
                            <Iconify icon="eva:eye-fill" />
                          </IconButton>
                        </TableCell>
                        <TableCell align="left">{row.name}</TableCell>
                        <TableCell align="left">{row.fromyear}</TableCell>
                        <TableCell align="left">{row.toyear}</TableCell>
                        <TableCell align="left">{row.imageUrl}</TableCell>

                        <TableCell align="left">
                          <SecretaryMoreMenu
                            onEdit={() => handleOpenModal(row._id)}
                            onDelete={() => handleDeletesecretary(row._id)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {issecretaryNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={secretary.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        {/* Modal for Editing secretary */}
        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>{editingsecretaryId ? "Edit secretary" : "Add New secretary"}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Name"
              type="text"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <TextField
              margin="dense"
              id="fromyear"
              label="From Year"
              type="text"
              fullWidth
              value={fromyear}
              onChange={(e) => setFromYear(e.target.value)}
            />
            <TextField
              margin="dense"
              id="toyear"
              label="To Year"
              type="text"
              fullWidth
              value={toyear}
              onChange={(e) => setToYear(e.target.value)}
            />
            <TextField
              margin="dense"
              id="imageUrl"
              label="Image URL"
              type="text"
              fullWidth
              value={imageUrl}
              onChange={(e) => setImageUrl(e.target.value)}
            />
          <Divider sx={{ my: 2 }} />
            <Paper sx={{ p: 2, mt: 2, bgcolor: "#fff3e0", border: "1px solid #ffcc80" }}>
  <Typography variant="subtitle2" sx={{ fontWeight: "bold", mb: 1 }}>
    📌 Image Guidelines
  </Typography>

  <Typography variant="body2">
    • Upload square image (1:1 ratio) <br />
    • Recommended size: <b>800 × 800 px</b> <br />
    • Keep face centered (head & shoulders) <br />
    • Avoid extra background space <br />
    • Supported: Google Drive link or image URL
  </Typography>
</Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal}>Cancel</Button>
            {editingsecretaryId ? (
              <Button onClick={handleUpdatesecretary}>Update secretary</Button>
            ) : (
              <Button onClick={handleAddsecretary}>Add secretary</Button>
            )}
          </DialogActions>
        </Dialog>

        <Dialog open={viewModalOpen} onClose={() => setViewModalOpen(false)}>
          <DialogTitle>Secretary Details</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              id="name"
              label="Name"
              type="text"
              fullWidth
              value={selectedsecretary?.name}
              disabled
            />
            <TextField
              margin="dense"
              id="fromyear"
              label="From Year"
              type="text"
              fullWidth
              value={selectedsecretary?.fromyear}
              disabled
            />
            <TextField
              margin="dense"
              id="toyear"
              label="To Year"
              type="text"
              fullWidth
              value={selectedsecretary?.toyear}
              disabled
            />
            <TextField  
              margin="dense"
              id="imageUrl"
              label="Image URL"
              type="text"
              fullWidth
              value={selectedsecretary?.imageUrl}
              disabled
            />

          </DialogContent>
          <DialogActions>
            <Button onClick={() => setViewModalOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>


      </Container>
    </Page>
  );
}
